import { HTTP } from '@/common/utils/http';

export const ResetPasswordService = {
    createResetToken(email) {
        return HTTP.post(`/no-auth/forgetPassword?email=${encodeURIComponent(email)}`);
    },

    resetPassword(form) {
        return HTTP.post(`/no-auth/forgetPassword/resetPassword`, form);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/reset-password.service.js